export default "__VITE_ASSET__f2df525e__"